import { FormAdapterBase } from '../form-adapter-base';
import { FormGroup, Validators } from '@angular/forms';
import { AddressFormGroup } from '../../interfaces/address';

export class AddressValidatorAdapter<T extends FormGroup> extends FormAdapterBase<T, AddressFormGroup> {
    private applied = false;

    public apply(): void {
        this.addValidators();
    }

    private addValidators(): void {
        if (this.applied) {
            return;
        }

        const addressForm = this.getTargetForm();
        addressForm.get('street1')!.setValidators([Validators.required]);
        addressForm.get('city')!.setValidators([Validators.required]);
        addressForm.get('state')!.setValidators([Validators.required]);
        addressForm.get('zip')!.setValidators([Validators.required]);
        addressForm.get('country')!.setValidators([Validators.required]);
        addressForm.get('addressType')!.setValidators([Validators.required]);
        addressForm.get('mortgageAmount')!.setValidators([Validators.required]);
        addressForm.get('rentalAmount')!.setValidators([Validators.required]);
        addressForm.get('startDate')!.setValidators([Validators.required]);
        addressForm.get('endDate')!.setValidators([Validators.required]);
        addressForm.get('isCurrent')!.setValidators([Validators.required]);

        addressForm.updateValueAndValidity();
        this.applied = true;
    }
}
